export default __webpack_public_path__ + "static/char-55-85c9f1eb6f65fc67dae704e9ed8f4b99.gif";